import apiClient from '../utils/apiClient';

class OrderService {
  // Get all orders for a restaurant
  async getOrders(restaurantId, options = {}) {
    const { page, limit, from, to, isActive, orderType } = options;
    const params = new URLSearchParams();
    
    if (restaurantId) params.append('restaurant', restaurantId);
    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    if (from) params.append('from', from);
    if (to) params.append('to', to);
    if (isActive !== undefined && isActive !== null) params.append('isActive', isActive);
    if (orderType) params.append('orderType', orderType);
    
    const endpoint = params.toString() ? `/orders?${params.toString()}` : '/orders';
    const response = await apiClient.get(endpoint);
    return response;
  }

  // Get single order
  async getOrder(orderId) {
    const response = await apiClient.get(`/orders/${orderId}`);
    return response;
  }

  // Create new order
  async createOrder(orderData) {
    const response = await apiClient.post('/orders', orderData);
    return response;
  }

  // Update order
  async updateOrder(orderId, orderData) {
    const response = await apiClient.patch(`/orders/${orderId}`, orderData);
    return response;
  }

  // Delete order
  async deleteOrder(orderId) {
    const response = await apiClient.delete(`/orders/${orderId}`);
    return response;
  }

  // Checkout order
  async checkoutOrder(orderId) {
    const response = await apiClient.post(`/orders/${orderId}/checkout`);
    return response;
  }

  // Update item status
  async updateItemStatus(orderId, itemIndex, status) {
    const response = await apiClient.patch(`/orders/${orderId}/items/${itemIndex}/status`, { status });
    return response;
  }
}

const orderService = new OrderService();
export default orderService;
